import React, { useMemo, useState } from 'react';
import { Modal, Table, Radio, message } from 'antd';
import range from 'lodash/range';
import { ExportListOpportunityReconciliation } from './newquery';
import { useLazyQuery } from '@apollo/client';
import { dayFormatType, formatDay } from '~helpers/day';
import formatMoney from '~helpers/currency';
import { formatUppercaseLetters, processBookingSystem } from '~helpers/change-log';
import ExportJsonExcel from 'js-export-excel';
// import { GET_BOOKING_ORDER } from '../queries';

const DOWNLOADCOUNT = 200;
function ExportData({ t, visible, onClose, total, queryFilter }) {
  const [tableData] = useState({ totalCount: total });

  const [exportLoading, setExportLoading] = useState(false);
  const [checkedIndex, setCheckedIndex] = useState(0);

  const handleDownloadBooking = () => {
    setExportLoading(true);

    queryDownload({
      variables: {
        ...queryFilter,
        pageSize: DOWNLOADCOUNT,
        pageNumber: checkedIndex + 1,
      },
    });
  };
  const handleChecked = idx => {
    setCheckedIndex(idx);
  };
  const exportDataModal = useMemo(() => {
    let modalData = [];
    if (tableData?.totalCount % DOWNLOADCOUNT === 0) {
      modalData = range(tableData?.totalCount / DOWNLOADCOUNT - 1);
    } else {
      modalData = range(tableData?.totalCount / DOWNLOADCOUNT);
    }

    return modalData.map(item => ({
      value: item,
    }));
  }, [tableData?.totalCount]);

  const getColumns = useMemo(
    () => [
      {
        title: '',
        dataIndex: 'value',
        key: 'value',
        render: (_, record) => {
          const value = record.value;
          return (
            <Radio
              checked={checkedIndex === value}
              className="radio-item"
              onClick={() => handleChecked(value)}
            >
              <span style={{ marginRight: 12 }}>{t('cms.sidebar.menu.booking')}</span>
              <span className="num-wrapper">{value * DOWNLOADCOUNT + 1}</span>
              <span className="dash">-</span>
              <span className="num-wrapper">
                {value === exportDataModal.length - 1
                  ? tableData?.totalCount
                  : (value + 1) * DOWNLOADCOUNT}
              </span>
            </Radio>
          );
        },
      },
    ],
    [checkedIndex, exportDataModal],
  );
  const combineName = (firstName, lastName) => {
    let name = '';
    if (firstName) {
      name += firstName;
    }
    if (firstName && lastName) {
      name += ` ${lastName}`;
    } else if (lastName) {
      name = lastName;
    } else {
      name = '-';
    }
    return name;
  };

  const [queryDownload, { loading }] = useLazyQuery(ExportListOpportunityReconciliation, {
    variables: {
      pageNumber: 1,
      pageSize: 20,
    },
    fetchPolicy: 'no-cache',
    onError: e => {
      message.error(e?.toString());
    },
    onCompleted: result => {
      let exceldata = result.listOpportunityReconciliation?.edges?.map((data, index) => {
        return {
          index: checkedIndex * 1000 + 1 + index,
          a: data?.referenceId ?? '-',
          b: data?.landlordApplicationId ?? '-',
          c: combineName(data?.student?.firstName, data?.student?.lastName),

          d: data?.student?.emailAddress ?? '-',
          e: data?.city?.name ?? '-',
          ab: data?.city?.country?.name ?? '-',
          f: data?.completedXbooking?.landlordName ?? '-',
          g: data?.completedXbooking?.propertyName ?? '-',
          h: data?.completedXbooking?.roomName ?? '-',
          i: data?.completedXbooking?.unitPrice ?? '-',
          j: data?.completedAt ? formatDay(dayFormatType.UKFORMAT, data?.completedAt) : '-',
          k: data?.finalMoveInDate ? formatDay(dayFormatType.UKFORMAT, data?.finalMoveInDate) : '-',
          l: data?.finalMoveOutDate
            ? formatDay(dayFormatType.UKFORMAT, data?.finalMoveOutDate)
            : '-',
          m: data?.tenancyLength?.weeks ?? '-',
          n: data?.tenancyLength?.days ?? '-',
          o: data?.finalPrice ?? '-',
          oi: data?.completedXbooking?.commission?.totalCommissionValue ?? '-',
          p: data?.booking?.commissionData?.tier?.calculationValue ?? '-',
          q: data?.booking?.commissionData?.tier?.calculationType ?? '-',
          r: data?.completedXbooking?.currency ?? '-',
          s:
            formatUppercaseLetters(
              data?.landlordBookingStatus?.toLowerCase?.()?.split?.('_')?.join?.(' '),
            ) ?? '-',
          t:
            formatUppercaseLetters(
              data?.secondaryLandlordBookingStatus?.toLowerCase?.()?.split?.('_')?.join?.(' '),
            ) ?? '-',
          u: data?.ownedBy ?? '-',
          v: processBookingSystem(data?.landlordApplicationSystem) ?? '-',
          w:
            data?.opportunityNote?.reconciliationNote?.length >= 30
              ? `${data?.opportunityNote?.reconciliationNote?.slice(0, 30)}...`
              : data?.opportunityNote?.reconciliationNote ?? '-',
          x: data?.completedXbooking?.commission?.invoiceNumber ?? '-',
          y: data?.completedXbooking?.commission?.actualInvoicedValue
            ? formatMoney(
                data?.completedXbooking?.commission?.actualInvoicedValue,
                data?.completedXbooking?.currency,
              )
            : '-',
          z: data?.city?.country?.market ?? '-',
          aa: data?.createdAt ? formatDay(dayFormatType.UKFORMAT, data?.createdAt) : '-',
          ac: '',
        };
      });
      handleExportToExcel(exceldata, t, () => {
        setExportLoading(false);
      });
    },
  });

  return (
    <div>
      <Modal
        visible={visible}
        width={820}
        bodyStyle={{ padding: '32px 60px' }}
        okButtonProps={{ icon: 'download', loading: exportLoading || loading }}
        okText="Download"
        onOk={handleDownloadBooking}
        onCancel={onClose}
        className="booking__modal-wrapper"
      >
        <header className="title">{t('cms.booking.export_data.title')}</header>
        <subtitle className="subtitle">{t('cms.booking.export_data.subtitle')}</subtitle>
        <section className="modal-content">
          <div className="export-header">
            <span className="available-export">{t('cms.booking.modal.header')}</span>
            <span className="bookings-count">
              {t('cms.booking.modal.export_count', { count: tableData?.totalCount })}
            </span>
          </div>
          <Table dataSource={exportDataModal} columns={getColumns} />
        </section>
      </Modal>
    </div>
  );
}

export default ExportData;

export const handleExportToExcel = (xlsxData, t, callback = () => {}) => {
  const sheetHeader = [
    'Index',
    t('cms.reconciliation.list.table.booking_reference'),
    t('cms.reconciliation.list.table.booking_id_system'),
    t('cms.reconciliation.list.table.student_passport_name'),
    t('cms.reconciliation.list.table.email_address'),
    t('cms.reconciliation.list.table.destination_city'),
    'Destination country',
    t('cms.reconciliation.list.table.landlord_name'),
    t('cms.reconciliation.list.table.property_name'),
    t('cms.reconciliation.list.table.room_name'),
    t('cms.reconciliation.list.table.listing_price'),
    t('cms.reconciliation.list.table.completed_date'),
    t('cms.reconciliation.list.table.actual_move_in_date'),
    t('cms.reconciliation.list.table.actual_move_out_date'),
    t('cms.reconciliation.list.table.tenancy_length_weeks'),
    t('cms.reconciliation.list.table.tenancy_length_days'),
    t('cms.reconciliation.list.table.final_price'),
    t('cms.booking.manual_property.detail.commission_info.total_commission_charged'),
    t('cms.reconciliation.list.table.commission_value'),
    t('cms.reconciliation.list.table.commission_type'),
    t('cms.reconciliation.list.table.currency'),
    t('cms.reconciliation.list.table.landlord_booking_status'),
    t('cms.reconciliation.list.table.secondary_landlord_booking_status'),
    t('cms.reconciliation.list.table.booking_consultant'),
    t('cms.reconciliation.list.table.booking_system'),
    t('cms.reconciliation.list.table.supply_team_notes'),
    t('cms.reconciliation.list.table.invoice_number'),
    t('cms.reconciliation.list.table.actual_invoice_value'),
    t('cms.reconciliation.list.table.destination_market'),
    t('cms.reconciliation.list.table.created_date'),

    'Booking comments',
  ];

  const option = {};
  option['fileName'] = 'Booking -- Booking width Consultant';

  option['datas'] = [
    {
      sheetData: xlsxData,
      sheetHeader,
    },
  ];
  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
  callback();
};
